import React from "react";

const PassportError = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="95.915"
      height="124.699"
      viewBox="0 0 95.915 124.699"
    >
      <g
        id="Group_5108"
        data-name="Group 5108"
        transform="translate(9952.999 -213)"
      >
        <g
          id="Group_5015"
          data-name="Group 5015"
          transform="translate(-9953.494 213.005)"
        >
          <g
            id="Group_5058"
            data-name="Group 5058"
            transform="translate(0.995 0.995)"
          >
            <path
              id="Rectangle_1585"
              data-name="Rectangle 1585"
              d="M8-.5H73.609a8.51,8.51,0,0,1,8.5,8.5v97.591a8.51,8.51,0,0,1-8.5,8.5H8a8.51,8.51,0,0,1-8.5-8.5V8A8.51,8.51,0,0,1,8-.5ZM73.609,113.091a7.508,7.508,0,0,0,7.5-7.5V8a7.508,7.508,0,0,0-7.5-7.5H8A7.508,7.508,0,0,0,.5,8v97.591a7.508,7.508,0,0,0,7.5,7.5Z"
              transform="translate(0 9.608)"
            />
            <path
              id="Ellipse_350"
              data-name="Ellipse 350"
              d="M23.343-.5a23.85,23.85,0,0,1,9.281,45.813A23.849,23.849,0,0,1,14.062,1.374,23.694,23.694,0,0,1,23.343-.5Zm0,46.687A22.85,22.85,0,0,0,32.235,2.295a22.849,22.849,0,0,0-17.783,42.1A22.7,22.7,0,0,0,23.343,46.187Z"
              transform="translate(17.461 33.134)"
            />
            <path
              id="Ellipse_351"
              data-name="Ellipse 351"
              d="M8.115-.5c2.4,0,4.6,2.547,6.21,7.173a52.732,52.732,0,0,1,2.4,16.67,52.732,52.732,0,0,1-2.4,16.67c-1.608,4.626-3.814,7.173-6.21,7.173s-4.6-2.547-6.21-7.173A52.732,52.732,0,0,1-.5,23.343,52.732,52.732,0,0,1,1.9,6.673C3.513,2.047,5.718-.5,8.115-.5Zm0,46.687c1.91,0,3.83-2.37,5.266-6.5A51.723,51.723,0,0,0,15.73,23.343,51.723,51.723,0,0,0,13.381,7C11.945,2.87,10.025.5,8.115.5S4.285,2.87,2.849,7A51.723,51.723,0,0,0,.5,23.343,51.723,51.723,0,0,0,2.849,39.686C4.285,43.817,6.2,46.187,8.115,46.187Z"
              transform="translate(32.689 33.134)"
            />
            <path
              id="Line_367"
              data-name="Line 367"
              d="M42.086.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H42.086a.5.5,0,0,1,.5.5A.5.5,0,0,1,42.086.5Z"
              transform="translate(19.762 48.363)"
            />
            <path
              id="Line_368"
              data-name="Line 368"
              d="M42.086.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H42.086a.5.5,0,0,1,.5.5A.5.5,0,0,1,42.086.5Z"
              transform="translate(19.762 64.592)"
            />
            <path
              id="Line_369"
              data-name="Line 369"
              d="M42.086.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H42.086a.5.5,0,0,1,.5.5A.5.5,0,0,1,42.086.5Z"
              transform="translate(19.762 89.746)"
            />
            <path
              id="Line_370"
              data-name="Line 370"
              d="M27.218.5H0A.5.5,0,0,1-.5,0,.5.5,0,0,1,0-.5H27.218a.5.5,0,0,1,.5.5A.5.5,0,0,1,27.218.5Z"
              transform="translate(27.196 99.672)"
            />
            <path
              id="Path_2163"
              data-name="Path 2163"
              d="M1,46.77a.5.5,0,0,1-.5-.5V19.114A10.456,10.456,0,0,1,9.324,8.786L60.9.631a10.457,10.457,0,0,1,12.072,9.7.5.5,0,0,1-1,.059A9.445,9.445,0,0,0,61.053,1.619L9.48,9.774a9.456,9.456,0,0,0-7.98,9.34V46.27A.5.5,0,0,1,1,46.77Z"
              transform="translate(-1 -1)"
            />
          </g>
        </g>
        <g
          id="Group_5107"
          data-name="Group 5107"
          transform="translate(-7633.836 -744.258) rotate(90)"
        >
          <path
            id="Path_1960"
            data-name="Path 1960"
            d="M42.111,22.729A14.306,14.306,0,1,0,27.806,37.034,14.3,14.3,0,0,0,42.111,22.729"
            transform="translate(943.758 2214.825)"
            fill="#c00051"
          />
          <path
            id="Path_1961"
            data-name="Path 1961"
            d="M13.609,11.694l-4.965-4.9,4.9-4.963L11.7,0,6.791,4.965,1.829.062,0,1.914l4.963,4.9L.062,11.78l1.849,1.829,4.9-4.965,4.965,4.9Z"
            transform="translate(978.369 2230.749) rotate(90)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
};

export default PassportError;
